import { render, staticRenderFns } from "./emailList.vue?vue&type=template&id=44361afd&scoped=true"
import script from "./emailList.vue?vue&type=script&lang=js"
export * from "./emailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44361afd",
  null
  
)

export default component.exports